import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { Link } from 'react-router-dom';
import {  listUsers } from '../actions/userActions';
import { AlertMessage } from '../components/AlertMessage'
import { LoadingBox } from '../components/LoadingBox'
import { ToolBar } from '../components/ToolBar';
import Select from "react-select"
import { listCourses } from '../actions/courseActions';
import { STUDENT_UPDATE_RESET } from '../constants/studentConstants';
import { detailsStudent, listStudents, updateStudent } from '../actions/studentActions';
import Swal from 'sweetalert2';
import { getNotificationsUser } from '../actions/notificationActions';

export const StudentEditScreen = () => {
    const navigate = useNavigate();
    const params = useParams();
    const studentId = params.id;

    const [name, setName] = useState('');
    const [code, setCode] = useState('');

    const studentDetails = useSelector(state => state.studentDetails);
    const { loading, error, student } = studentDetails;

    const studentUpdate = useSelector(state => state.studentUpdate);
    const { loading: loadingUpdate, error: errorUpdate, success: successUpdate } = studentUpdate;

    const userList = useSelector(state => state.userList);
    const { loading: loadingUsers, error: errorUsers, users } = userList;
    

    const courseList = useSelector((state) => state.courseList);
    const { loading: loadingCourses, error: errorCourses, courses } = courseList;

    const dispatch = useDispatch();

    // Select de Usuarios 
    
    const [usersOptions, setUsersOptions] = useState([])
    const selectedUsers = [];
    const [selectedOptions, setSelectedOptions] = useState([])

    // Select de Cursos
    let selectedCourse = null;
    // const courseOptions = []
    const [courseOptions, setCourseOptions] = useState([])
    const [selectedCourseOptions, setSelectedCourseOptions] = useState([])

    // Emergency phone options
    const [emergencyPhoneOptions, setEmergencyPhoneOptions] = useState([])
    const [selectedEmergencyPhoneOptions, setSelectedEmergencyPhoneOptions] = useState([])
    

    useEffect(() => {
        // Rellenamos el select de padres
        if (users) {
            setUsersOptions([])
            users.map((usuario) => (
                setUsersOptions((usersOptions) => [...usersOptions, { value: usuario._id, label: usuario.name }])
            ))            
        }
        
        // Rellenamos el select de cursos
        if (courses) {
            setCourseOptions([])
            courses.map((course) => (
                setCourseOptions((courseOptions) => [...courseOptions, { value: course._id, label: course.name }])            
            ))
        }
        
        // Rellenamos el select de teléfonos de emergencias
        if (student) {
            setEmergencyPhoneOptions([])
            student.userParents.map((parent) => (
                setEmergencyPhoneOptions((emergencyPhoneOptions) => [...emergencyPhoneOptions, { value: parent.phone, label: `${parent.phone} - ${parent.name}` }])
            ))
        }
 
    }, [users, courses, student])

    useEffect(() => {
        if (successUpdate) {
            dispatch({ type: STUDENT_UPDATE_RESET });
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Alumno editado correctamente',
                showConfirmButton: false,
                timer: 1500
            })
            dispatch(detailsStudent(studentId))
        }

        if (!student) {
            dispatch(detailsStudent(studentId))
        }
        else {
            setName(student.name)                                    
            setCode(student.code)
            // if (student.userParents && !loading) {
            //     student.userParents.map((parent) => (
            //         emergencyPhoneOptions.push({ value: parent.phone, label: parent.phone })
            //     ))
            // }
        }
        dispatch(listStudents())
        dispatch(listCourses())
        dispatch(listUsers())
        dispatch(getNotificationsUser());

    }, [dispatch, student, studentId, navigate, successUpdate])


    useEffect(() => {    
        if (users && student) {
           
            // Recuperamos el curso del alumno
            if (student.course) {                
                setSelectedCourseOptions(courseOptions.find(option => option.value === student.course._id));
            }

            if (student.userParents) {
                // Recuperamos el teléfono de emergencias del alumno
                setSelectedEmergencyPhoneOptions(emergencyPhoneOptions.find(option => option.value === student.emergencyPhone));

                // Recuperamos los padres del alumno
                let arrayValores = [];
                student.userParents.map((parent) => (
                    arrayValores.push(usersOptions.find(option => option.value === parent._id))
                ))
                setSelectedOptions(arrayValores);
            }
            
            
        }
    }, [users, student, courseOptions, usersOptions])

    useEffect(()=>{
        let options = []
        selectedOptions.forEach(element => {
            let parent = users?.find(us => us._id === element?.value)
            if (parent) {
                options.push({value: parent.phone, label: `${parent.phone} - ${parent.name}`})
            }
        })
        setEmergencyPhoneOptions(options)
    }, [ selectedOptions, users])

    const submitHandler = (e) => {
        e.preventDefault();

        // Añadir objetos de hijos al padre
        for (const user of users) {        
            for (const selectedOption of selectedOptions) {
                if (user._id === selectedOption.value) {
                    selectedUsers.push(user)
                }                
            }
        }
        
        // Añadir cursos al usuario
        if (selectedCourseOptions !== null) {
            selectedCourse = courses.find(course => course._id === selectedCourseOptions.value)    
        }else {
            selectedCourse = '';  
        }
        dispatch(updateStudent({
            _id: studentId,
            name,                        
            userParents: selectedUsers,
            course: selectedCourse,  
            emergencyPhone: selectedEmergencyPhoneOptions ? selectedEmergencyPhoneOptions.value : null,
            code
        }));
    }

    const handleCourseChange = (selectedCourseOptions) => {
        setSelectedCourseOptions(selectedCourseOptions)
    }

    const handleChange = (selectedOptions) => {
        setSelectedOptions(selectedOptions)
    }

    const handleEmergencyPhoneChange = (selectedPhoneOptions) => {
        setSelectedEmergencyPhoneOptions(selectedPhoneOptions)
    }

    

    return (
        <>
            <ToolBar titulo={"Editar alumno"} hitos={[
                { titulo: "Inicio", enlace: "/" },
                { titulo: "Alumnos", enlace: "/studentlist" },
                { titulo: "Editar alumno", enlace: "#" }]} />
            <div id="kt_content_container" className="d-flex flex-column-fluid align-items-start container-xxl">
                <div className="content flex-row-fluid" id="kt_content">
                    <div>
                        {loadingUpdate && <LoadingBox variant={"primary"} />}
                        {errorUpdate && <AlertMessage variant={"danger"} message={errorUpdate} />}
                    </div>
                    {
                        loading ? <LoadingBox variant={"primary"} /> :
                        error ? <AlertMessage variant={"danger"} message={error} /> :
                        <>
                            <div className="card mb-5 mb-xl-10">
                                <div className="card-body pt-9 pb-0">
                                    <div className="d-flex flex-wrap flex-sm-nowrap mb-3">
                                        <div className="me-7 mb-4">
                                            <div className="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
                                                <img src="/assets/media/avatars/blank.png" alt="Avatar" />
                                                <div className="position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px"></div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                                                <div className="d-flex flex-column">
                                                    <div className="d-flex align-items-center mb-2">
                                                        <Link to={"/#"} className="text-gray-900 text-hover-primary fs-2 fw-bolder me-1">{name}</Link>
                                                        <Link to={"/#"}>
                                                            <span className="svg-icon svg-icon-1 svg-icon-primary">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                                                                    <path d="M10.0813 3.7242C10.8849 2.16438 13.1151 2.16438 13.9187 3.7242V3.7242C14.4016 4.66147 15.4909 5.1127 16.4951 4.79139V4.79139C18.1663 4.25668 19.7433 5.83365 19.2086 7.50485V7.50485C18.8873 8.50905 19.3385 9.59842 20.2758 10.0813V10.0813C21.8356 10.8849 21.8356 13.1151 20.2758 13.9187V13.9187C19.3385 14.4016 18.8873 15.491 19.2086 16.4951V16.4951C19.7433 18.1663 18.1663 19.7433 16.4951 19.2086V19.2086C15.491 18.8873 14.4016 19.3385 13.9187 20.2758V20.2758C13.1151 21.8356 10.8849 21.8356 10.0813 20.2758V20.2758C9.59842 19.3385 8.50905 18.8873 7.50485 19.2086V19.2086C5.83365 19.7433 4.25668 18.1663 4.79139 16.4951V16.4951C5.1127 15.491 4.66147 14.4016 3.7242 13.9187V13.9187C2.16438 13.1151 2.16438 10.8849 3.7242 10.0813V10.0813C4.66147 9.59842 5.1127 8.50905 4.79139 7.50485V7.50485C4.25668 5.83365 5.83365 4.25668 7.50485 4.79139V4.79139C8.50905 5.1127 9.59842 4.66147 10.0813 3.7242V3.7242Z" fill="#00A3FF" />
                                                                    <path className="permanent" d="M14.8563 9.1903C15.0606 8.94984 15.3771 8.9385 15.6175 9.14289C15.858 9.34728 15.8229 9.66433 15.6185 9.9048L11.863 14.6558C11.6554 14.9001 11.2876 14.9258 11.048 14.7128L8.47656 12.4271C8.24068 12.2174 8.21944 11.8563 8.42911 11.6204C8.63877 11.3845 8.99996 11.3633 9.23583 11.5729L11.3706 13.4705L14.8563 9.1903Z" fill="white" />
                                                                </svg>
                                                            </span>
                                                        </Link>
                                                    </div>
                                                    {student.userParents.length > 0 &&
                                                        <div className="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2">
                                                            <div className="text-hover-primary fs-3 fw-bolder me-1">Padres</div>
                                                            {student.userParents.map((padre) => (
                                                                <div className="col-12" key={padre.name}>{padre.name}</div>
                                                            ))}
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card mb-5 mb-xl-10">
                                <div className="card-header border-0 cursor-pointer" role="button" data-bs-toggle="collapse" data-bs-target="#kt_account_profile_details" aria-expanded="true" aria-controls="kt_account_profile_details">
                                    <div className="card-title m-0">
                                        <h3 className="fw-bolder m-0">Datos del alumno</h3>
                                    </div>
                                </div>
                                <div id="kt_account_settings_profile_details" className="collapse show">
                                    <form autoComplete='off' id="kt_account_profile_details_form" className="form" onSubmit={submitHandler}>
                                        <div className="card-body border-top p-9">
                                            <h3 className="fw-bolder mx-0 my-5">Datos generales</h3>                 
                                            <div className="row mb-6">
                                                <label className="col-lg-4 col-form-label required fw-bold fs-6">Nombre</label>
                                                <div className="col-lg-8">
                                                    <div className="row">
                                                        <div className="col-lg-12 fv-row">
                                                            <input className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" id="name" type="text" placeholder="Introduce el nombre" value={name} onChange={(e) => setName(e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>                                                                                                        
                                            <div className="row mb-6">
                                                <label className="col-lg-4 col-form-label required fw-bold fs-6">Código</label>
                                                <div className="col-lg-8">
                                                    <div className="row">
                                                        <div className="col-lg-12 fv-row">
                                                            <input className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" id="code" type="text" placeholder="Introduce el codigo escolar" value={code} onChange={(e) => setCode(e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>                                                
                                            <div className="row mb-6">
                                                <label className="col-lg-4 col-form-label required fw-bold fs-6">Teléfono de emergencias</label>
                                                <div className="col-lg-8">
                                                    <div className="row">
                                                        <div className="col-lg-12 fv-row">
                                                        {loading ? (<LoadingBox variant={"primary"} />) :
                                                                error ? (<AlertMessage variant={"danger"} message={error} />) : (
                                                                    <Select isClearable options={emergencyPhoneOptions} value={selectedEmergencyPhoneOptions} onChange={handleEmergencyPhoneChange}  placeholder="Teléfono de emergencias del alumno" />
                                                                )}                                                            
                                                        </div> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mb-6">
                                                <label className="col-lg-4 col-form-label required fw-bold fs-6">Padres</label>
                                                <div className="col-lg-8">
                                                    <div className="row">
                                                        <div className="col-lg-12 fv-row">
                                                            {loadingUsers ? (<LoadingBox variant={"primary"} />) :
                                                                errorUsers ? (<AlertMessage variant={"danger"} message={errorUsers} />) : (
                                                                    <Select isMulti isClearable options={usersOptions} onChange={handleChange} value={selectedOptions} placeholder="Escoja los padres del alumno" />
                                                                    
                                                                )}
                                                                <div className="text-muted fs-7">Escoja uno a uno los padres del alumno. Tambien puede buscarlos escribiendo parte del nombre.</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mb-6">
                                                <label className="col-lg-4 col-form-label required fw-bold fs-6">Curso escolar</label>
                                                <div className="col-lg-8">
                                                    <div className="row">
                                                        <div className="col-lg-12 fv-row">

                                                            {loadingCourses ? (<LoadingBox variant={"primary"} />) :
                                                                errorCourses ? (<AlertMessage variant={"danger"} message={errorCourses} />) : (
                                                                    <Select isClearable options={courseOptions} onChange={handleCourseChange} value={selectedCourseOptions} placeholder="Curso escolar del alumno" />
                                                                )}
                                                                <div className="text-muted fs-7">Escoja un curso. Tambien puede buscarlo escribiendo parte del nombre.</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-footer d-flex justify-content-end py-6 px-9">
                                            <button type="submit" className="btn btn-primary" id="kt_account_profile_details_submit">Actualizar usuario</button>
                                            <Link id="kt_ecommerce_add_product_cancel" className="btn btn-light ms-5" to={`/studentlist`}>Cancelar</Link>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </>
    )
}
